// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1IaSjl","inline":"emgdYA","block":"_1BoYif","fullWidth":"_1udEV5","trigger":"_30anQr","button":"_1wJvrA","icon":"_3qh7ju","icon--disabled":"tD4w1g"};